import { EditProfile } from '../components/ui/EditProfile';
type EditProfileScreenProps = {
    screenName: string;
    screenKey: string;
};

export const EditProfileScreen: React.FC<EditProfileScreenProps> = ({ screenName, screenKey }) => {
    return (
        <>
            <EditProfile />
        </>
    );
};
